const jQ = jQuery.noConflict();
class SetCircleText {
	constructor(circleText) {
		this.circleText = circleText;
	}
	init() {
		jQ(this.circleText).lettering('');
	}
}

export default new SetCircleText('.circle-text');